import React from 'react';
import {Map, List} from 'immutable';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {checkoutInputStyle, mobileCheckoutInputStyle} from './styles';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const CustomerEmail = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    return (
      <input
        {...generateAttributes(attributes, classes)}
        type="text"
        name="email"
        required
      />
    );
  }
);

const staticBindings = Map({
  value: List([
    Map({
      slug: 'customerEmail',
      type: 'PlainText',
    }),
  ]),
});

const config = createIntegratedAtom({
  displayName: 'Email',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: CustomerEmail,
  fields: {},
  style: {
    base: {
      main: {
        ...checkoutInputStyle,
        noPseudo: {
          ...checkoutInputStyle.noPseudo,
          marginBottom: px(0),
        },
      },
      tiny: mobileCheckoutInputStyle,
    },
  },
  staticBindings,
});

export default config;
